import * as ro from "./offline/route";
import db from "./database";
import store from "./store/index";
import moment from "moment";
import axios from "axios";
import * as msg from "./message";
// import * as socket from "./socket";
import _ from "lodash";

export const isObject = (data) => {
  if (!(data instanceof Object)) {
    return false;
  } else {
    return data;
  }
};

export const isStringEmpty = (data) => {
  let check = false;
  if (/^\s*$/.test(data)) check = true;
  return check;
};

export const makeid = (length) => {
  let result = "";
  let characters =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  let charactersLength = characters.length;
  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
};

export const offlineAPI = (data, type) => {
  if (
    store.state.billing.billing.hasOwnProperty("billing_mode") &&
    store.state.billing.billing.billing_mode != "normal"
  )
    return;
  let parseData = [];
  if (!data.hasOwnProperty("config")) return;
  let API = data.config;
  if (API.method == "get") {
    parseData = API.params;
  } else {
    if (type == "online") {
      parseData = data;
    } else {
      parseData = JSON.parse(API.data);
    }
  }
  return ro.routeToFunction(API.baseURL, API.url, parseData);
};

export const getInvoiceId = async (data) => {
  let invoice_no = "";
  let invoice_id_format =
    store.state.system.settings.vendor_app_menu.offline
      .offline_invoice_id_format;

  let date_format = [];
  let date_data = invoice_id_format.date_format.name;
  let reset = "";
  let date = moment(new Date()).format("DD");
  let month = moment(new Date()).format("M");
  let year = moment(new Date()).format("YY");
  let id_length = invoice_id_format.order_id.name.length;

  if (invoice_id_format.prefix.status == 1) {
    invoice_no += invoice_id_format.prefix.name;
    if (data == "order_id") {
      invoice_no = "OF" + invoice_no.slice(1);
    }
  }

  if (invoice_id_format.short_code.status == 1) {
    invoice_no += invoice_id_format.short_code.name;
  }

  if (invoice_id_format.terminal_code.status == 1) {
    invoice_no += invoice_id_format.terminal_code.name;
  }

  if (invoice_id_format.date_format.status == 1) {
    if (date_data.hasOwnProperty("date")) {
      date_format[date_data.date.ordersequence - 1] = date;
      if (date_data.date.reset == "1") {
        reset = "date";
      }
    }
    if (date_data.hasOwnProperty("month")) {
      date_data.month.month_list.map((item) => {
        if (item.name == month) {
          date_format[date_data.month.ordersequence - 1] = item.value;
        }
      });
      if (date_data.month.reset == "1") {
        reset = "month";
      }
    }
    if (date_data.hasOwnProperty("year")) {
      date_format[date_data.year.ordersequence - 1] = year;
      if (date_data.year.reset == "1") {
        reset = "year";
      }
    }
    if (date_format.length != 0) {
      date_format.map((item) => {
        invoice_no += item;
      });
    }
  }
  if (invoice_id_format.order_id.status == 1) {
    if (data == "order_id") {
      await db.invoiceId
        .where("[store_id+vu_id+v_id]")
        .equals([
          parseInt(store.state.sessions.user.store_id),
          parseInt(store.state.sessions.user.vu_id),
          parseInt(store.state.sessions.user.v_id),
        ])
        .reverse()
        .and((filter) => {
          return filter.order_id != "";
        })
        .first((item) => {
          if (item != undefined) {
            console.log("not empty");

            let invoice_date = moment(item.date).format("DD");
            let invoice_month = moment(item.date).format("M");
            let invoice_year = moment(item.date).format("YY");

            let order_no = "";
            let invoice_id = item.order_id;
            console.log(invoice_id);
            let reset_flag = false;
            if (reset == "date") {
              if (
                (date != invoice_date &&
                  month == invoice_month &&
                  year == invoice_year) ||
                (date != invoice_date &&
                  month != invoice_month &&
                  year == invoice_year) ||
                (date != invoice_date &&
                  month != invoice_month &&
                  year != invoice_year) ||
                (date == invoice_date &&
                  month == invoice_month &&
                  year != invoice_year) ||
                (date == invoice_date &&
                  month != invoice_month &&
                  year == invoice_year)
              ) {
                reset_flag = true;
              } else {
                reset_flag = false;
              }
            } else if (reset == "month") {
              if (
                (month != invoice_month && year == invoice_year) ||
                (month == invoice_month && year != invoice_year) ||
                (month != invoice_month && year != invoice_year)
              ) {
                reset_flag = true;
              } else {
                reset_flag = false;
              }
            } else if (reset == "year") {
              if (year != invoice_year) {
                reset_flag = true;
              } else {
                reset_flag = false;
              }
            }

            if (reset_flag == true) {
              let order_reset = "1";
              order_reset = order_reset.padStart(id_length, "0");
              invoice_no += order_reset;
            } else if (reset_flag == false) {
              order_no = parseInt(
                invoice_id.substring(invoice_id.length - id_length)
              );
              order_no = (order_no + 1).toString();
              order_no = order_no.padStart(id_length, "0");
              invoice_no += order_no;
            }
            store.commit("billing/setOrderIdOffline", invoice_no);
          } else {
            invoice_no += invoice_id_format.order_id.name;
            store.commit("billing/setOrderIdOffline", invoice_no);
          }
        });
    } else if (data == "invoice_id") {
      await db.invoiceId
        .where("[store_id+vu_id+v_id]")
        .equals([
          parseInt(store.state.sessions.user.store_id),
          parseInt(store.state.sessions.user.vu_id),
          parseInt(store.state.sessions.user.v_id),
        ])
        .reverse()
        .and((filter) => {
          return filter.invoice_id != "";
        })
        .first((item) => {
          if (item != undefined) {
            console.log("not empty");

            let invoice_date = moment(item.date).format("DD");
            let invoice_month = moment(item.date).format("M");
            let invoice_year = moment(item.date).format("YY");

            let order_no = "";
            let invoice_id = item.invoice_id;
            console.log(invoice_id);
            let reset_flag = false;
            if (reset == "date") {
              if (
                (date != invoice_date &&
                  month == invoice_month &&
                  year == invoice_year) ||
                (date != invoice_date &&
                  month != invoice_month &&
                  year == invoice_year) ||
                (date != invoice_date &&
                  month != invoice_month &&
                  year != invoice_year) ||
                (date == invoice_date &&
                  month == invoice_month &&
                  year != invoice_year) ||
                (date == invoice_date &&
                  month != invoice_month &&
                  year == invoice_year)
              ) {
                reset_flag = true;
              } else {
                reset_flag = false;
              }
            } else if (reset == "month") {
              if (
                (month != invoice_month && year == invoice_year) ||
                (month == invoice_month && year != invoice_year) ||
                (month != invoice_month && year != invoice_year)
              ) {
                reset_flag = true;
              } else {
                reset_flag = false;
              }
            } else if (reset == "year") {
              if (year != invoice_year) {
                reset_flag = true;
              } else {
                reset_flag = false;
              }
            }

            if (reset_flag == true) {
              let order_reset = "1";
              order_reset = order_reset.padStart(id_length, "0");
              invoice_no += order_reset;
            } else if (reset_flag == false) {
              order_no = parseInt(
                invoice_id.substring(invoice_id.length - id_length)
              );
              order_no = (order_no + 1).toString();
              order_no = order_no.padStart(id_length, "0");
              invoice_no += order_no;
            }
            store.commit("billing/setInvoiceIdOffline", invoice_no);
          } else {
            invoice_no += invoice_id_format.order_id.name;
            store.commit("billing/setInvoiceIdOffline", invoice_no);
          }
        });
    }
  }
  let new_invoice = {
    invoice_number: invoice_no,
    // order_id: order_id_inc
  };
  console.log(invoice_no);
  return new_invoice;
};

export const getOrderId = async (data) => {
  let invoice_no = "";
  let invoice_id_format =
    store.state.system.settings.vendor_app_menu.offline
      .offline_invoice_id_format;

  let date_format = [];
  let date_data = invoice_id_format.date_format.name;
  let reset = "";
  let date = moment(new Date()).format("DD");
  let month = moment(new Date()).format("M");
  let year = moment(new Date()).format("YY");

  let order_no = "";
  let prev_order_id = "";

  let id_length = invoice_id_format.order_id.name.length;

  if (invoice_id_format.prefix.status == 1) {
    invoice_no += invoice_id_format.prefix.name;
    invoice_no = "H" + invoice_no.slice(1);
  }

  if (invoice_id_format.short_code.status == 1) {
    invoice_no += invoice_id_format.short_code.name;
  }

  if (invoice_id_format.terminal_code.status == 1) {
    invoice_no += invoice_id_format.terminal_code.name;
  }

  if (invoice_id_format.date_format.status == 1) {
    if (date_data.hasOwnProperty("date")) {
      date_format[date_data.date.ordersequence - 1] = date;
      if (date_data.date.reset == "1") {
        reset = "date";
      }
    }
    if (date_data.hasOwnProperty("month")) {
      date_data.month.month_list.map((item) => {
        if (item.name == month) {
          date_format[date_data.month.ordersequence - 1] = item.value;
        }
      });
      if (date_data.month.reset == "1") {
        reset = "month";
      }
    }
    if (date_data.hasOwnProperty("year")) {
      date_format[date_data.year.ordersequence - 1] = year;
      if (date_data.year.reset == "1") {
        reset = "year";
      }
    }
    if (date_format.length != 0) {
      date_format.map((item) => {
        invoice_no += item;
      });
    }
  }
  if (invoice_id_format.order_id.status == 1) {
    await db.invoice
      .orderBy("id")
      .reverse()
      .first(async (item) => {
        if (item != undefined) {
          console.log("not empty");

          let invoice_date = moment(item.date).format("DD");
          let invoice_month = moment(item.date).format("M");
          let invoice_year = moment(item.date).format("YY");

          // console.log(invoice_id);
          let reset_flag = false;
          if (reset == "date") {
            if (
              (date != invoice_date &&
                month == invoice_month &&
                year == invoice_year) ||
              (date != invoice_date &&
                month != invoice_month &&
                year == invoice_year) ||
              (date != invoice_date &&
                month != invoice_month &&
                year != invoice_year) ||
              (date == invoice_date &&
                month == invoice_month &&
                year != invoice_year) ||
              (date == invoice_date &&
                month != invoice_month &&
                year == invoice_year)
            ) {
              reset_flag = true;
            } else {
              reset_flag = false;
            }
          } else if (reset == "month") {
            if (
              (month != invoice_month && year == invoice_year) ||
              (month == invoice_month && year != invoice_year) ||
              (month != invoice_month && year != invoice_year)
            ) {
              reset_flag = true;
            } else {
              reset_flag = false;
            }
          } else if (reset == "year") {
            if (year != invoice_year) {
              reset_flag = true;
            } else {
              reset_flag = false;
            }
          }

          if (reset_flag == true) {
            let order_reset = "1";
            order_reset = order_reset.padStart(id_length, "0");
            invoice_no += order_reset;
          } else if (reset_flag == false) {
            await db.order
              .orderBy("id")
              .reverse()
              .and((filter) => {
                return filter.status == "hold";
              })
              .first((item) => {
                if (item != undefined) {
                  prev_order_id = item.order_id;
                  order_no = parseInt(
                    prev_order_id.substring(prev_order_id.length - id_length)
                  );
                  order_no = (order_no + 1).toString();
                  order_no = order_no.padStart(id_length, "0");
                  invoice_no += order_no;
                } else {
                  invoice_no += invoice_id_format.order_id.name;
                }
              });
          }
          store.commit("billing/setOrderIdHoldOffline", invoice_no);
        } else {
          let count_hold = 0;
          await db.order
            .orderBy("id")
            .reverse()
            .and((filter) => {
              return filter.status == "hold";
            })
            .count((item) => {
              count_hold = item;
            });

          if (count_hold != 0) {
            await db.order
              .orderBy("id")
              .reverse()
              .and((filter) => {
                return filter.status == "hold";
              })
              .first((item) => {
                prev_order_id = item.order_id;
                order_no = parseInt(
                  prev_order_id.substring(prev_order_id.length - id_length)
                );
                order_no = (order_no + 1).toString();
                order_no = order_no.padStart(id_length, "0");
                invoice_no += order_no;
              });
          } else {
            invoice_no += invoice_id_format.order_id.name;
          }

          store.commit("billing/setOrderIdHoldOffline", invoice_no);
        }
      });
  }
  console.log(invoice_no);
};

export const syncSessionOnline = (type) => {
  store.commit("billing/removeCustomer");
  store.state.sessions.loading = true;
  let session_data = [];
  db.transaction("rw", db.session, db.cart, async () => {
    await db.cart
      .where("[store_id+vu_id+v_id]")
      .equals([
        parseInt(store.state.sessions.user.store_id),
        parseInt(store.state.sessions.user.vu_id),
        parseInt(store.state.sessions.user.v_id),
      ])
      .and((filter) => {
        return filter.status == "process";
      })
      .each(async (item) => {
        if (item != undefined) {
          await db.cart.delete(item.id);
        }
      });
    session_data = await db.session
      .orderBy("id")
      .and((filter) => {
        return (
          filter.sync == 0 &&
          parseInt(filter.vu_id) == parseInt(store.state.sessions.user.vu_id)
        );
      })
      .toArray();
    await db.session
      .where("vu_id")
      .equals(parseInt(store.state.sessions.user.vu_id))
      .first((item) => {
        if (item != undefined) {
          if (item.closing_balance == null && item.closing_time == null) {
            store.commit("sessions/setSessionId", item.id);
          } else {
            store.commit("sessions/setSessionId", 0);
          }
        }
      });
  }).then(() => {
    if (session_data.length != 0) {
      let data = {
        session_data: JSON.stringify(session_data),
        url: "/vendor/out-bound-table-sync",
      };

      let blob = new Blob([JSON.stringify(data)], {
        type: "text/plain",
      });
      let fd = new FormData();

      fd.append("vu_id", store.state.sessions.user.vu_id);
      fd.append("type", "session");
      fd.append("store_id", store.state.sessions.user.store_id);
      fd.append("udidtoken", store.state.system.licence);
      fd.append("trans_from", store.state.system.trans_from);
      fd.append("v_id", store.state.sessions.user.v_id);
      fd.append("api_token", store.state.sessions.user.api_token);
      fd.append("terminal_id", store.state.system.settings.terminal_id);
      fd.append("session", blob, "rajat");

      axios
        .post(data.url, fd)
        .then(() => {
          session_data.forEach(async (element) => {
            await db.session.update(element.id, {
              sync: 1,
            });
            if (type == "setting") {
              store
                .dispatch("system/getLatestSettings")
                .then(() => {
                  store.commit("sessions/disableLoading");
                })
                .catch(() => store.commit("sessions/disableLoading"));
            }
          });
        })
        .then(() => {
          if (type != "setting") {
            getSettingsAndRemove();
          }
        })
        .catch(() => {
          let alertData = {
            message: msg.INTERNAL_SERVER_ERROR,
            type: "danger",
          };
          store.commit("notifications/showAlert", alertData);
          store.state.sessions.loading = false;
          store.commit("sessions/disableLoading");
        });
    } else {
      if (type != "setting") {
        getSettingsAndRemove();
      } else {
        store.commit("sessions/disableLoading");
      }
    }
  });
};

const getSettingsAndRemove = () => {
  let productData = {
    barcode: "",
    url: "remove-product-from-cart",
    product_id: "",
    cart_id: "",
    all: "1",
  };
  let pushData = Object.assign(
    productData,
    store.getters["sessions/getEssentialsData"],
    store.getters["sessions/getCustomerParam"]
  );
  store
    .dispatch("billing/cancelBill", pushData)
    .then(() => {
      store
        .dispatch("system/getLatestSettings")
        .then(() => {
          store.state.sessions.loading = false;
          store.commit("sessions/disableLoading");
        })
        .catch(() => store.commit("sessions/disableLoading"));
    })
    .catch(() => {
      let alertData = {
        message: msg.INTERNAL_SERVER_ERROR,
        type: "danger",
      };
      store.commit("notifications/showAlert", alertData);
      store.state.sessions.loading = false;
      store.commit("sessions/disableLoading");
    });
};

export const switchToOffline = () => {
  if (
    store.state.billing.billing.refund_mode ||
    store.state.billing.billing.billing_mode == "order"
  ) {
    store.state.notifications.message.text = store.state.billing.billing
      .refund_mode
      ? msg.ADHOC_RETURN_OFFLINE_CANCEL
      : msg.ORDER_POS_OFFLINE_CANCEL;
    store.state.notifications.message.btnText = "Cancel";
    store.state.notifications.message.type = "cancel_return";
    return;
  }
  store.state.notifications.message.text = msg.INTERNET_OFFLINE;
  store.state.notifications.message.btnText = "Continue";
  store.state.notifications.message.type = "state_change";
  store.state.sessions.loading = true;
  let data = {};
  data.vendor = store.state.sessions.user.api_token;
  if (store.state.billing.billing.customer.data != "") {
    data.user_id = store.state.billing.billing.customer.data.c_id;
    data.dumuy_customer = store.state.billing.billing.customer.data.api_token;
  } else {
    data.user_id = store.state.billing.billing.dumuy_customer.c_id;
    data.dumuy_customer = store.state.billing.billing.dumuy_customer.api_token;
  }
  store.commit("billing/setTransactionSubType", "normal");
  changeUserId();
};

export const changeUserId = () => {
  let c_id = store.state.billing.billing.dumuy_customer.c_id;
  db.transaction(
    "rw",
    db.cart,
    db.customer,
    db.session,
    db.order,
    db.payment,
    async () => {
      let cartNotEmpty = false;
      await db.cart.count((count) => {
        if (count != 0) {
          cartNotEmpty = true;
        }
      });
      if (cartNotEmpty) {
        await db.cart
          .orderBy("id")
          .and((filter) => {
            return (
              filter.status == "process" ||
              filter.status == "hold" ||
              filter.status == "order_process"
            );
          })
          .each(async (item) => {
            if (item != undefined) {
              // if (
              //   item.user_id != store.state.billing.billing.dumuy_customer.c_id
              // ) {
              await db.customer.get(
                {
                  online_c_id: parseInt(item.user_id),
                },
                async (cust) => {
                  if (cust != undefined) {
                    c_id = cust.id;
                    await db.cart.update(item.id, {
                      user_id: cust.id,
                    });
                  }
                }
              );
              // }
            }
          });
      } else if (
        !cartNotEmpty &&
        store.state.billing.billing.customer.data.hasOwnProperty("c_id")
      ) {
        {
          await db.customer.get(
            {
              online_c_id: parseInt(
                store.state.billing.billing.customer.data.c_id
              ),
            },
            (cust) => {
              if (cust != undefined) c_id = cust.id;
            }
          );
        }
      }

      await db.session
        .where("vu_id")
        .equals(parseInt(store.state.sessions.user.vu_id))
        .and((filter) => {
          return filter.closing_balance == null && filter.closing_time == null;
        })
        .first(async (item) => {
          if (item != undefined) {
            await db.session.update(item.id, {
              sync: 0,
            });
          }
        });
    }
  )
    .then(async () => {
      if (c_id != store.state.billing.billing.dumuy_customer.c_id) {
        store.commit("billing/setOfflineUserId", c_id);
      }
      if (store.state.billing.billing.order.data != "") {
        let order_id = "";
        await db.order
          .where("online_order_id")
          .equals(store.state.billing.billing.order.data.order_id)
          .first((item) => {
            if (item != undefined) {
              order_id = item.order_id;
              db.order.update(item.id, {
                sync: 0,
              });
            }
          })
          .then(() => {
            if (order_id != "") {
              store.commit("billing/replaceWithOfflineOrderId", order_id);
            } else {
              store.commit("billing/replaceWithOfflineOrderId", "");
            }
          });
      }
    })
    .then(async () => {
      let order_in_process = false;
      await db.cart
        .orderBy("id")
        .and((filter) => {
          return filter.status == "order_process";
        })
        .each((item) => {
          if (item != undefined && item.status == "order_process") {
            order_in_process = true;
          }
        });

      let customer_id = 0;
      await db.customer.get(
        {
          online_c_id: store.state.billing.billing.dumuy_customer.c_id,
        },
        (c) => (customer_id = c.id)
      );
      await db.setting
        .where("user_id")
        .equals(parseInt(store.state.sessions.user.vu_id))
        .first(async (s) => {
          if (s != undefined) {
            if (s.settings.hasOwnProperty("settings"))
              s.settings.settings.vendor_login_details.c_id = customer_id;
            else s.settings.vendor_login_details.c_id = customer_id;
            await db.setting.update(s.id, s);
          }
          store.commit("billing/setDummyCustomerId", customer_id);
          store.commit("system/offlineUpdateDummyCustomerId", customer_id);
        });

      if (!order_in_process) {
        store.dispatch("billing/cartDetails").then(() => {
          store.commit("sessions/disableLoading");
        });
      } else {
        store.commit("sessions/disableLoading");
      }
    })
    .catch(() => {
      store.commit("sessions/disableLoading");
    });
};

export const syncDataInbound = () => {
  if (
    store.state.system.isOffline == false &&
    store.state.system.settings.vendor_app_menu.hasOwnProperty("offline") &&
    store.state.system.settings.vendor_app_menu.offline.status == 1
  ) {
    store.dispatch("offline/saveUserWiseSettings").then(() => {
      store.dispatch("offline/saveOfflineStoreUser");
      store.dispatch("offline/saveOfflineSession");
      let date_time = {};
      date_time.data = moment().format("MMMM Do YYYY, h:mm:ss A");
      date_time.index = 0;
      store.commit("offline/setDate", date_time);
    });
  }
};

export const verifyOfflineState = () => {
  let count = 0;
  db.transaction("rw", db.cart, async () => {
    await db.cart
      .where("[store_id+vu_id+v_id]")
      .equals([
        parseInt(store.state.sessions.user.store_id),
        parseInt(store.state.sessions.user.vu_id),
        parseInt(store.state.sessions.user.v_id),
      ])
      .and((filter) => {
        return filter.status != "hold";
      })
      .count((item) => {
        count = item;
      });
  }).then(() => {
    if (count == 0) {
      store.state.notifications.message.text = msg.INTERNET_ONLINE;
      store.state.notifications.message.btnText = "Continue";
      store.state.notifications.message.type = "state_change";
      syncApiToken();
    } else {
      store.state.notifications.message.text =
        store.state.billing.billing.order.data == ""
          ? msg.DECIDE_OFFLINE
          : msg.DECIDE_OFFLINE_ORDER;
      store.state.notifications.message.btnText = "Continue";
      store.state.notifications.message.type = "decide";
    }
  });
};

export const syncApiToken = () => {
  let customer_id = 0;
  db.customer.get(
    { id: store.state.billing.billing.dumuy_customer.c_id },
    (c) => {
      if (c != undefined) customer_id = c.online_c_id;
    }
  );
  db.setting
    .where("user_id")
    .equals(parseInt(store.state.sessions.user.vu_id))
    .first(async (s) => {
      if (s != undefined) {
        if (s.settings.hasOwnProperty("settings"))
          s.settings.settings.vendor_login_details.c_id = customer_id;
        else s.settings.vendor_login_details.c_id = customer_id;
        await db.setting.update(s.id, s);
      }
      store.commit("billing/setDummyCustomerId", customer_id);
      // store.commit("system/offlineUpdateDummyCustomerId", customer_id);
    });
  // socket.getItems();
  console.log("[SYNCING API TOKEN]");
  store.state.sessions.loading = true;
  let data = {
    v_id: store.state.sessions.user.v_id,
    store_id: store.state.sessions.user.store_id,
    customer_token:
      store.state.billing.billing.customer.data == ""
        ? store.state.billing.billing.dumuy_customer.api_token
        : store.state.billing.billing.customer.data.api_token,
    c_id:
      store.state.billing.billing.customer.data == ""
        ? store.state.billing.billing.dumuy_customer.c_id
        : store.state.billing.billing.customer.data.c_id,
    vu_id: store.state.sessions.user.vu_id,
    vendor_token: store.state.sessions.user.api_token,
    url: "/switch-to-online",
  };
  axios
    .post(data.url, data)
    .then(async () => {
      await store.dispatch("system/getLatestSettings");
      syncSessionOnline();
    })
    .catch(() => {
      syncSessionOnline();
      store.commit("sessions/disableLoading");
    });
};

// export const outBoundInvoiceSync = () => {
//   let cool = {};
//   cool.item_list = [];
//   cool.payment_list = [];
//   cool.customer = {};
//   let customer_id = 0;
//   let invoice_no = "";
//   let invoice_id = [];
//   let order_id = "";
//   let remark = "";
//   let session_id = 0;
//   db.transaction(
//     "rw",
//     db.invoice,
//     db.payment,
//     db.order,
//     db.customer,
//     async () => {
//       await db.order
//         .orderBy("id")
//         .and((filter) => {
//           order_id = filter.id;
//           return filter.status == "success" && filter.sync == 0;
//         })
//         .first()
//         .then(async (item) => {
//           remark = item.bill_remark;
//           session_id = item.session_id;
//           invoice_id = JSON.parse(item.cart_id);
//           invoice_id.map(async (product) => {
//             await db.invoice.get(product).then((cart_item) => {
//               invoice_no = cart_item.invoice_no;
//               customer_id = cart_item.user_id;
//               cool.invoice_no = cart_item.invoice_no;
//               cool.date = cart_item.date;
//               cool.time = cart_item.time;
//               cool.item_list.push(cart_item);
//             });
//           });
//         });
//     }
//   )
//     .then(async () => {
//       await db.payment
//         .where("invoice_id")
//         .equals(invoice_no)
//         .each((payment) => {
//           cool.payment_list.push(payment);
//         });
//     })
//     .then(async () => {
//       await db.customer
//         .where("id")
//         .equals(customer_id)
//         .each((customer) => {
//           cool.customer = customer;
//         });
//     })
//     .then(async () => {
//       let data = {
//         transaction_type: "sales",
//         transaction_sub_type: "sales",
//         terminal_id: store.state.system.settings.terminal_id,
//         customer: JSON.stringify(cool.customer),
//         item_list: JSON.stringify(cool.item_list),
//         payment_list: JSON.stringify(cool.payment_list),
//         invoice_no: invoice_no,
//         date: cool.date,
//         time: cool.time,
//         remark: remark,
//         session_id: session_id,
//         url: "/vendor/out-bound-table-sync",
//       };
//       let stringCool = JSON.stringify(data);
//       var blob = new Blob([stringCool], { type: "text/plain" });
//       console.log(data.invoice_no);
//       var fd = new FormData();
//       fd.append("type", "invoice");
//       fd.append("api_token", store.state.sessions.user.api_token);
//       fd.append("vu_id", store.state.sessions.user.vu_id);
//       fd.append("v_id", store.state.sessions.user.v_id);
//       fd.append("store_id", store.state.sessions.user.store_id);
//       fd.append("trans_from", store.state.system.trans_from);
//       fd.append("udidtoken", store.state.system.licence);
//       fd.append("terminal_id", data.terminal_id);
//       fd.append("invoice_data", blob, "rajat");

//       axios.post(data.url, fd).then(async (response) => {});
//     });
// };

export const downloadInvoiceData = (order, type) => {
  let cool = {};
  cool.item_list = [];
  cool.payment_list = [];
  cool.customer = {};
  let customer_id = 0;
  let invoice_no = "";
  let invoice_id = [];
  let remark = "";
  let session_id = 0;
  db.transaction(
    "rw",
    db.invoice,
    db.payment,
    db.order,
    db.customer,
    async () => {
      await db.order
        .where("order_id")
        .equals(order)
        .first()
        .then(async (item) => {
          remark = item.bill_remark;
          session_id = item.session_id;
          invoice_id = JSON.parse(item.cart_id);
          invoice_id.map(async (product) => {
            await db.invoice.get(product).then((cart_item) => {
              invoice_no = cart_item.invoice_no;
              customer_id = cart_item.user_id;
              cool.invoice_no = cart_item.invoice_no;
              cool.date = cart_item.date;
              cool.time = cart_item.time;
              cool.item_list.push(cart_item);
            });
          });
        });
    }
  )
    .then(async () => {
      await db.payment
        .where("invoice_id")
        .equals(invoice_no)
        .each((payment) => {
          cool.payment_list.push(payment);
        });
    })
    .then(async () => {
      await db.customer
        .where("id")
        .equals(customer_id)
        .each((customer) => {
          cool.customer = customer;
        });
    })
    .then(async () => {
      let data = {
        transaction_type: "sales",
        transaction_sub_type: "sales",
        store_id: store.state.sessions.user.store_id,
        terminal_id: store.state.system.settings.terminal_id,
        vu_id: store.state.sessions.user.vu_id,
        v_id: store.state.sessions.user.v_id,
        type: "invoice",
        api_token: store.state.sessions.user.api_token,
        trans_from: store.state.system.trans_from,
        udidtoken: store.state.system.trans_from,
        customer: JSON.stringify(cool.customer),
        item_list: JSON.stringify(cool.item_list),
        payment_list: JSON.stringify(cool.payment_list),
        invoice_no: invoice_no,
        date: cool.date,
        time: cool.time,
        remark: remark,
        session_id: session_id,
        url: "/vendor/out-bound-table-sync",
      };
      let stringCool = btoa(JSON.stringify(data));
      var blob = new Blob([stringCool], {
        type: "application/json",
      });
      var url = URL.createObjectURL(blob);

      let download = document.createElement("a");
      download.href = url;
      download.download = data.invoice_no;
      if (type == "socket") {
        let newData = JSON.stringify(data);
        var blob = new Blob([newData], {
          type: "text/plain",
        });
      } else {
        download.click();
      }
    });
};

export const cancelReturnInOffline = () => {
  store.state.sessions.loading = true;
  let order_state = "";
  if (
    store.state.billing.billing.order.data.hasOwnProperty("order_id") &&
    store.state.billing.billing.order.data.order_id != ""
  ) {
    db.transaction("rw", db.cart, db.order, db.invoiceId, async () => {
      order_state = "online_order_id";
      await db.order
        .where(order_state)
        .equals(store.state.billing.billing.order.data.order_id.toString())
        .first()
        .then((prod) => {
          let products = JSON.parse(prod.cart_id);
          products.map((item) => {
            db.cart.update(item, {
              status: "process",
            });
          });
          db.order.delete(prod.id);
        });
      await db.invoiceId
        .where(order_state)
        .equals(store.state.billing.billing.order.data.order_id.toString())
        .delete();
    })
      .then(() => {
        let productData = {
          barcode: "",
          url: "remove-product-from-cart",
          product_id: "",
          cart_id: "",
          all: "1",
        };
        let pushData = Object.assign(
          productData,
          store.getters["sessions/getEssentialsData"],
          store.getters["sessions/getCustomerParam"]
        );
        store.dispatch("billing/cancelBill", pushData).then(() => {
          let anchor = document.createElement("a");
          anchor.href = "#/billing";
          anchor.click();
          switchToOffline();
        });
      })
      .catch(() => {
        store.commit("sessions/disableLoading");
      });
  } else {
    let productData = {
      barcode: "",
      url: "remove-product-from-cart",
      product_id: "",
      cart_id: "",
      all: "1",
    };
    let pushData = Object.assign(
      productData,
      store.getters["sessions/getEssentialsData"],
      store.getters["sessions/getCustomerParam"]
    );
    store
      .dispatch("billing/cancelBill", pushData)
      .then(() => {
        switchToOffline();
      })
      .catch(() => {
        store.commit("sessions/disableLoading");
      });
  }
};

export const checkPosStatus = (type) => {
  if (type == "online") {
    store.state.notifications.message.text = msg.INTERNET_AVAILABLE;
    store.state.notifications.message.btnText = "Continue";
    store.state.notifications.message.type = "no_internet";
  } else {
    store.state.notifications.message.text = msg.INTERNET_UNAVAILABLE;
    store.state.notifications.message.btnText = "Continue";
    store.state.notifications.message.type = "no_internet";
  }
};

export const clearAllStores = () => {
  db.cart.clear();
  db.customer.clear();
  db.invoice.clear();
  db.invoiceId.clear();
  db.logs.clear();
  db.order.clear();
  db.payment.clear();
  db.products.clear();
  db.session.clear();
  db.setting.clear();
  db.stock.clear();
  db.user.clear();
};

export const billingModeFilter = (data) => {
  let urlSplit = data.url.split("/");
  let urlArrayList = [
    "cart-details",
    "product-details",
    "product-qty-update",
    "process-to-payment",
    "gv/process-to-payment",
    "save-payment",
    "gv/save-payment",
  ];
  if (urlArrayList.includes(urlSplit[urlSplit.length - 1])) {
    if (store.state.billing.trans_sub_type == "order") {
      data.data.trans_type = store.state.billing.trans_sub_type;
      return data;
    }
    data.data.trans_type = store.state.billing.billing.billing_mode;
    if (
      data.data.hasOwnProperty("transaction_sub_type") &&
      store.state.billing.billing.billing_mode == "order"
    ) {
      data.data.transaction_sub_type = "order";
    }
  }
  return data;
};

export const isEmpty = (value) => {
  return (
    value === undefined ||
    value === null ||
    (typeof value === "object" && Object.keys(value).length === 0) ||
    (typeof value === "string" && value.trim().length === 0) ||
    value === "0" ||
    value == 0
  );
};
export const countProducts = () => {
  return new Promise((resolve) => {
    let count = 0;
    db.transaction("r", db.products, async () => {
      await db.products.count((item) => {
        count = item;
      });
    }).then(() => {
      resolve(count);
    });
  });
};

export const getRange = (data) => {
  let temp = [];
  for (let i = 1; i <= parseInt(data); i++) {
    temp.push(i);
  }
  return temp;
};

export const checkOfflineData = () => {
  return new Promise((resolve) => {
    let user = 0;
    let setting = 0;
    db.transaction("r", db.user, db.setting, async () => {
      user = await db.user.count();
      setting = await db.setting.count();
    }).then(() => {
      let temp = false;
      if (user != 0 && setting != 0) temp = true;
      resolve(temp);
    });
  });
};

export const checkSpecialCharacter = (key) => {
  let char = [
    "!",
    "@",
    "#",
    "$",
    "%",
    "^",
    "&",
    "*",
    "-",
    "_",
    "=",
    "+",
    "(",
    ")",
    "{",
    "}",
    "[",
    "]",
    "/",
    "|",
    ":",
    ";",
    "'",
    '"',
    "<",
    ">",
    ",",
    ".",
    "?",
  ];
  let temp = false;
  if (_.includes(char, key)) temp = true;
  return temp;
};

export const checkInvoiceId = () => {
  return new Promise(async (resolve) => {
    if (
      !store.state.system.settings.vendor_app_menu.hasOwnProperty("offline") ||
      store.state.system.settings.vendor_app_menu.offline.status == 0 ||
      (store.state.system.settings.vendor_app_menu.offline.status == 1 &&
        store.state.system.isOffline)
    ) {
      return resolve(true);
    }
    let invoice_id = "";
    let created_at = "";
    let seq = "";
    let insert = false;
    const seqLength =
      store.state.system.settings.vendor_app_menu.offline
        .offline_invoice_id_format.order_id.name.length;

    let data = {
      url: "/latest-invoice-id",
    };
    data = Object.assign(data, store.getters["sessions/getCustomerParam"]);
    await axios.post(data.url, data).then((res) => {
      if (res.data.status == "success") {
        invoice_id = res.data.data.invoice_id;
        created_at = res.data.data.created_at;
        seq = parseInt(invoice_id.slice(-seqLength));
      } else resolve(true);
    });

    db.transaction("rw", db.invoiceId, async () => {
      await db.invoiceId.get(
        {
          invoice_id: invoice_id,
        },
        async (item) => {
          if (item == undefined) {
            let count = await db.invoiceId
              .orderBy("id")
              .and((filter) => {
                return filter.invoice_id != "";
              })
              .count();

            let invoices = await db.invoiceId
              .orderBy("id")
              .and((filter) => {
                return (
                  filter.invoice_id != "" &&
                  filter.invoice_id != invoice_id &&
                  seq > parseFloat(filter.invoice_id.slice(-seqLength))
                );
              })
              .toArray();
            if (count == invoices.length) insert = true;
            else if (invoices.length < count) insert = false;
          }
        }
      );
    }).then(async () => {
      if (insert) {
        if (moment().isSameOrAfter(created_at, "YYYY-MM-DD")) {
          let insertData = {
            order_id: "",
            invoice_id: invoice_id,
            type: "online->api",
            v_id: parseInt(store.state.sessions.user.v_id),
            store_id: parseInt(store.state.sessions.user.store_id),
            vu_id: parseInt(store.state.sessions.user.vu_id),
            date: moment(created_at).format("YYYY-MM-DD"),
            time: moment(created_at).format("HH:mm:ss"),
            online_order_id: 0,
          };
          db.invoiceId.put(insertData);
        }
      }
      resolve(true);
    });
  });
};

export const downloadEinvoive = () => {
  let data = Object.assign(
    {
      url: "einvoice-download",
      invoice_id: store.state.billing.billing.invoice.data.invoice_id,
    },
    store.getters["sessions/getCustomerParam"]
  );
  let download = document.createElement("a");
  download.href =
    process.env.VUE_APP_API_URL +
    data.url +
    "?url=" +
    data.url +
    "&invoice_id=" +
    data.invoice_id +
    "&v_id=" +
    data.v_id +
    "&store_id=" +
    data.store_id +
    "&trans_from=" +
    data.trans_from +
    "&c_id=" +
    data.c_id +
    "&api_token=" +
    data.api_token +
    "&vu_id=" +
    data.vu_id +
    "&customer_group_code=" +
    data.customer_group_code +
    "&udidtoken=" +
    store.state.system.licence +
    "&terminal_id=" +
    store.state.system.settings.terminal_id +
    "&session_id=" +
    store.state.system.settings.settlement.settlement_session_id;
  download.download = data.invoice_id;
  download.target = "_blank";
  download.click();
};

export const hideMiddleText = (str) => {
  if (str == undefined) return "";
  let hidden = "";
  let temp = str.length % 3 == 0 ? 0 : 1;
  let ln = Math.floor(str.length / 3);
  hidden = str.slice(0, ln) + " ";
  let middle = str.slice(ln, ln * 2 + temp);
  for (let i = 0; i < middle.length; i++) {
    hidden += "*";
  }
  hidden += " " + str.slice(ln * 2 + temp, str.length);

  return hidden;
};

export const getSetting = () => {
  store.dispatch("system/getLatestSettings");
};

export const jobEntry = (type) => {
  const date = moment().format("YYYY-MM-DD");
  const time = moment().format("h:mm a");
  db.jobs
    .where("[type+date]")
    .equals([type, date])
    .first(async (job) => {
      if (job == undefined)
        await db.jobs.put({
          type: type,
          date: date,
          time: time,
        });
    });
};

export const deleteLogs = (date) => {
  return new Promise((resolve) => {
    db.transaction("rw", db.logs, db.jobs, async () => {
      await db.logs
        .orderBy("id")
        .and((filter) => {
          return moment(
            new Date(filter.date).format("YYYY-MM-DD")
          ).isSameOrBefore(moment(date).format("YYYY-MM-DD"));
        })
        .each(async (log) => await db.logs.delete(log.id));
    }).then(() => resolve(true));
  });
};

export const deleteSyncedData = (date) => {
  return new Promise((resolve) => {
    db.transaction("rw", db.order, db.invoice, db.payment, async () => {
      await db.invoice
        .orderBy("order_id")
        .and((filter) => {
          return (
            moment(new Date(filter.date)).isSameOrBefore(moment(date)) &&
            filter.sync == 1
          );
        })
        .eachUniqueKey(async (order_id) => {
          console.log(order_id);
          await db.order
            .where("order_id")
            .equals(order_id)
            .first(async () => {
              await db.invoice
                .where("order_id")
                .equals(order_id)
                .primaryKeys(async (inv) => db.invoice.bulkDelete(inv));
              await db.payment
                .where("order_id")
                .equals(order_id)
                .primaryKeys(async (pay) => db.payment.bulkDelete(pay));
              await db.order
                .where("order_id")
                .equals(order_id)
                .primaryKeys(async (odid) => db.order.bulkDelete(odid));
            });
        });
    }).then(() => resolve(true));
  });
};

export const clearOfflineCart = () => {
  let { v_id, store_id, vu_id } = store.getters["sessions/getCustomerParam"];
  db.cart
    .where("[store_id+vu_id+v_id]")
    .equals([store_id, vu_id, v_id])
    .and((filter) => {
      return filter.status == "process";
    })
    .primaryKeys((item) => db.cart.bulkDelete(item));
};
